import { createSlice } from '@reduxjs/toolkit';
import { createApi } from '../../../utils/api';

export const getOutboundSyncData = createApi(`OutboundDataTableSlice`,"GET");

const OutboundDataTableSlice = createSlice({
  name: 'OutboundDataTableSlice',
  initialState: {
    data: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getOutboundSyncData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getOutboundSyncData.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getOutboundSyncData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
  },
});

export default OutboundDataTableSlice.reducer;